import { useSearchParams } from 'react-router-dom';

type ProjectFile = { name: string; content: string };

function transformImports(code: string, sessionId: string): string {
  return code.replace(/import\s+(.+?)\s+from\s+['"](.+?)['"]/g, (match, imp, path) => {
    if (path.startsWith('./')) {
      const fullPath = 'src/' + path.slice(2);
      return `import ${imp} from '/__sandbox_file/${sessionId}/${fullPath}'`;
    }
    return match;
  });
}

export default function SandboxEntry() {
  const [sp] = useSearchParams();
  const sessionId = sp.get('sessionId');
  if (!sessionId) throw new Response('Missing sessionId', { status: 400 });

  const filesKey = `dayone:sandbox:files:${sessionId}`;
  const filesStr = localStorage.getItem(filesKey);
  if (!filesStr) throw new Response('No files', { status: 404 });

  const files: ProjectFile[] = JSON.parse(filesStr);
  const mainFile = files.find(f => f.name === 'src/main.tsx' || f.name === 'src/main.jsx');
  if (!mainFile) throw new Response('No main file', { status: 404 });

  const code = transformImports(mainFile.content, sessionId);
  throw new Response(code, { headers: { 'Content-Type': 'application/javascript' } });
}
